import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './Teammember.css';

/* ── All team member data ── */
const TEAM_DATA = {
    'kodees': {
        name: 'Kodees',
        role: 'CEO & Technical Director',
        team: 'Leadership',
        color: '#e87c2a',   
        g1: '#e87c2a',
        g2: '#f5a623',
        photo: '/images/team/kodees.jpeg',
        about: 'Kodees is the visionary founder and CEO of DWB Tech Solution , driving the company\'s mission to deliver world-class PCB design and engineering services. With over 22 years of industry experience inherited through the parent company established in 1994, Kodees leads a global team of engineers across India, USA, Japan, and Vietnam.',
        expertise: ['Strategic Leadership', 'PCB Design Architecture', 'ASIC Verification', 'Global Operations', 'Business Development'],
        experience: '22+ Years',
        projects: '6500+',
        email: 'ceo@dwbtech.com',
        linkedin: '#',
        quote: '"Bring your requirement, walk away with a solution."',
    },

    'james-franklin': {
        name: 'James Franklin',
        role: 'US Sales',
        team: 'Sales Team',
        color: '#9b6dff',
        g1: '#7c5cbf',
        g2: '#9b6dff',
        photo: '/images/team/james-franklin.jpeg',
        about: 'James Franklin manages DWB Tech\'s North American sales operations, bringing deep relationships with US-based semiconductor and electronics companies. He is the primary contact for clients across the United States seeking high-speed PCB design, ATE boards, and engineering services.',
        expertise: ['US Market Strategy', 'Semiconductor Sales', 'ATE & PCB Solutions', 'Key Account Management', 'Technical Sales'],
        experience: '10+ Years',
        projects: '150+',
        email: 'us@dwbtech.com',
        linkedin: '#',
        quote: '"Delivering engineering excellence from coast to coast."',
    },
    'jayakumar': {
        name: 'Jayakumar',
        role: 'Director – Sales & Operations',
        team: 'Sales Team',
        color: '#9b6dff',
        g1: '#7c5cbf',
        g2: '#9b6dff',
        photo: '/images/team/jayakumar.jpeg',
        about: 'Jayakumar oversees DWB Tech\'s sales and operational alignment, ensuring seamless delivery from client acquisition through project completion. His dual role in both sales strategy and operations makes him a critical bridge between customer requirements and engineering execution.',
        expertise: ['Sales Operations', 'Project Management', 'Process Optimization', 'Team Leadership', 'Client Delivery'],
        experience: '10+ Years',
        projects: '300+',
        email: 'sales@dwbtech.com',
        linkedin: '#',
        quote: '"Operational excellence is the backbone of every successful delivery."',
    },
    'rathina-kumar': {
        name: 'Rathina Kumar',
        role: 'Director – Sales',
        team: 'Sales Team',
        color: '#9b6dff',
        g1: '#7c5cbf',
        g2: '#9b6dff',
        photo: '/images/team/rathina-kumar.jpeg',
        about: 'Rathina Kumar drives DWB Tech\'s sales initiatives with a focus on expanding the client base across key verticals including aerospace, automotive, medical, and semiconductor industries. His strategic approach and technical background enable him to communicate complex engineering value propositions effectively.',
        expertise: ['Sales Strategy', 'Vertical Markets', 'Technical Proposals', 'Revenue Growth', 'Market Expansion'],
        experience: '12+ Years',
        projects: '180+',
        email: 'sales@dwbtech.com',
        linkedin: '#',
        quote: '"Every client relationship is built on trust, transparency, and results."',
    },
    'rangaraj': {
        name: 'Rangaraj',
        role: 'Manager – PCB Design',
        team: 'Technical Team',
        color: '#4a90d9',
        g1: '#2563a8',
        g2: '#4a90d9',
        photo: '',
        about: 'Rangaraj leads DWB Tech\'s PCB Design division with deep expertise in high-speed, multilayer, and ATE board design. He manages a team of senior engineers and design leads responsible for delivering production-ready PCB designs with zero-rework quality standards.',
        expertise: ['High-Speed PCB Design', 'ATE Board Design', 'Signal Integrity', 'Multilayer Stackup', 'Design Rule Check'],
        experience: '15+ Years',
        projects: '400+',
        email: 'pcb@dwbtech.com',
        linkedin: '#',
        quote: '"Precision in every trace, perfection in every layer."',
    },
    'pushparaj': {
        name: 'Pushparaj',
        role: 'Manager – PCB',
        team: 'Technical Team',
        color: '#06b6d4',
        g1: '#0284c7',
        g2: '#06b6d4',
        photo: '',
        about: 'Pushparaj heads the PCB Engineering division at DWB Tech, overseeing PCB design, manufacturing, and integration for electronic systems. His team ensures that PCB assemblies meet both functional and physical constraints across aerospace, automotive, and industrial applications.',
        expertise: ['PCB Design', 'PCB Manufacturing', 'CAD/CAM', 'PCB Integration', 'Manufacturing DFM'],
        experience: '20+ Years',
        projects: '250+',
        email: 'pcb@dwbtech.com',
        linkedin: '#',
        quote: '"Where hardware meets precision — that\'s where we excel."',
    },
    'sadhish': {
        name: 'Sadhish',
        role: 'Manager – IoT',
        team: 'Technical Team',
        color: '#4a90d9',
        g1: '#2563a8',
        g2: '#4a90d9',
        photo: '/images/team/sadhish.jpeg',
        about: 'Sadhish leads DWB Tech\'s IoT division, specializing in connected device design, firmware development, and embedded systems. His team delivers end-to-end IoT solutions from hardware schematic to cloud connectivity, enabling clients to bring intelligent products to market faster.',
        expertise: ['IoT Architecture', 'Embedded Systems', 'Firmware Development', 'Wireless Protocols', 'Cloud Integration'],
        experience: '12+ Years',
        projects: '180+',
        email: 'iot@dwbtech.com',
        linkedin: '#',
        quote: '"Connecting the physical world to the digital future, one device at a time."',
    },
};

export default function TeamMember() {
    const { state } = useLocation();
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const member = state?.slug ? TEAM_DATA[state.slug] : null;

    useEffect(() => {
        const t = setTimeout(() => setLoaded(true), 80);
        return () => clearTimeout(t);
    }, []);

    if (!member) {
        return (
            <div className="tm-notfound">
                <h2>Member not found</h2>
                <button onClick={() => navigate('/about')} className="tm-back-btn">← Back to About</button>
            </div>
        );
    }

    return (
        <div className={`tm-page${loaded ? ' tm-page--loaded' : ''}`}>

            {/* ── Dark BG ── */}
            <div className="tm-bg" />
            <div className="tm-bg-overlay" />
            <div className="tm-bg-grid" />
            <div className="tm-bg-orb tm-bg-orb--1" style={{ background: `radial-gradient(circle, ${member.color}33, transparent 70%)` }} />
            <div className="tm-bg-orb tm-bg-orb--2" />

            {/* Particles */}
            {[...Array(8)].map((_, i) => (
                <div key={i} className={`tm-particle tm-particle--${i + 1}`} style={{ background: member.color }} />
            ))}

            <div className="tm-inner">

                {/* ── Back Button ── */}
                <button className="tm-back-btn" onClick={() => navigate('/about')}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <path d="M19 12H5M12 5l-7 7 7 7" />
                    </svg>
                    Back to Team
                </button>

                {/* ── Main Profile Card ── */}
                <div className="tm-profile">

                    {/* LEFT — Photo */}
                    <div className="tm-photo-col">
                        <div className="tm-photo-wrap" style={{ '--mc': member.color }}>
                            <div className="tm-photo-ring tm-photo-ring--1" />
                            <div className="tm-photo-ring tm-photo-ring--2" />
                            <div className="tm-photo-card">
                                <div className="tm-photo-avatar">
                                    <img src={member.photo} alt={member.name} className="tm-photo-img" />
                                </div>
                                <div className="tm-photo-overlay" />
                                {/* Scan line */}
                                {/* Corner accents */}
                                <span className="tm-corner tm-corner--tl" style={{ borderColor: member.color }} />
                                <span className="tm-corner tm-corner--tr" style={{ borderColor: member.color }} />
                                <span className="tm-corner tm-corner--bl" style={{ borderColor: member.color }} />
                                <span className="tm-corner tm-corner--br" style={{ borderColor: member.color }} />
                            </div>

                            {/* Team badge */}
                            <div className="tm-team-badge" style={{ borderColor: member.color, color: member.color }}>
                                <span className="tm-team-dot" style={{ background: member.color }} />
                                {member.team}
                            </div>

                            {/* Stats */}
                            <div className="tm-quick-stats">
                                <div className="tm-quick-stat">
                                    <div className="tm-quick-val" style={{ color: member.color }}>{member.experience}</div>
                                    <div className="tm-quick-label">Experience</div>
                                </div>
                                <div className="tm-quick-divider" />
                                <div className="tm-quick-stat">
                                    <div className="tm-quick-val" style={{ color: member.color }}>{member.projects}</div>
                                    <div className="tm-quick-label">Projects</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT — Info */}
                    <div className="tm-info-col">
                        {/* Name & Role */}
                        <div className="tm-name-wrap">
                            <div className="tm-role-tag" style={{ color: member.color, borderColor: `${member.color}44`, background: `${member.color}11` }}>
                                {member.role}
                            </div>
                            <h1 className="tm-name">{member.name}</h1>
                        </div>

                        {/* Quote */}
                        <div className="tm-quote" style={{ borderColor: member.color }}>
                            <div className="tm-quote-mark" style={{ color: member.color }}>"</div>
                            {member.quote.replace(/"/g, '')}
                        </div>

                        {/* About */}
                        <div className="tm-section">
                            <div className="tm-section-label" style={{ color: member.color }}>About</div>
                            <p className="tm-about-text">{member.about}</p>
                        </div>

                        {/* Expertise */}
                        <div className="tm-section">
                            <div className="tm-section-label" style={{ color: member.color }}>Areas of Expertise</div>
                            <div className="tm-expertise-grid">
                                {member.expertise.map((skill, i) => (
                                    <div key={i} className="tm-skill-pill" style={{ '--mc': member.color }}>
                                        <span className="tm-skill-dot" style={{ background: member.color }} />
                                        {skill}
                                    </div>
                                ))}
                            </div>
                        </div>



                        {/* CTA */}

                    </div>
                </div>
            </div>
        </div>
    );
}